/**
 * useQueryTabColumnSample — a Query Editor tab's last result rows for one
 * table column (`resultRowsForColumn`), for a filter chip opened on that tab's
 * statement (the Visual Query Editor's WHERE chip). Undefined when the tab has
 * no results carrying the column.
 */

import { useMemo } from 'react';

import { useWorkspaceStore } from '../../core/store/workspaceStore';
import { resultRowsForColumn, type ResultColumnTarget } from '../utils/resultColumnSample';

export function useQueryTabColumnSample(
  tabId: string | undefined,
  target: ResultColumnTarget | null,
): Record<string, unknown>[] | undefined {
  const resultSets = useWorkspaceStore((s) => {
    const tab = tabId ? s.tabs.find((t) => t.id === tabId) : undefined;
    return tab?.type === 'query' ? tab.content.resultSets : undefined;
  });
  const schema = target?.schema;
  const table = target?.table;
  const column = target?.column;
  return useMemo(
    () => (table && column ? resultRowsForColumn(resultSets, { schema, table, column }) : undefined),
    [resultSets, schema, table, column],
  );
}
